import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./settings-billing-current.module.scss";
import { VelavuInvoice } from "velavu-js-api";
import SettingsBillingStatusText from "./settings-billing-status-text";
import SettingsBillingSummaryCard from "./settings-billing-summary-card";
import SettingsBillingUsageTable from "./settings-billing-usage-table";

export interface SettingsBillingCurrentProps {
	invoice?: VelavuInvoice | "error" | null | undefined;
}

export default function SettingsBillingCurrent(
	props: SettingsBillingCurrentProps,
) {
	const { t } = useTranslation();

	return (
		<div className={styles.container}>
			<span className={styles.title}>
				{t("settings.billing.current_period")}
			</span>

			{!props.invoice ? (
				<SettingsBillingStatusText>
					{t("settings.billing.checking_usage")}
				</SettingsBillingStatusText>
			) : props.invoice === "error" ? (
				<SettingsBillingStatusText type="error">
					{t("settings.billing.usage_error")}
				</SettingsBillingStatusText>
			) : (
				<React.Fragment>
					<SettingsBillingSummaryCard
						start={props.invoice.period_start}
						end={props.invoice.period_end}
						total={props.invoice.total}
					/>

					<span className={styles.subtitle}>
						{t("settings.billing.usage_to_date")}
					</span>

					<SettingsBillingUsageTable usage={props.invoice.usage} />
				</React.Fragment>
			)}
		</div>
	);
}
